import { render } from "./SourceTypeFilter.vue?vue&type=template&id=12ece954&lang=pug"
import script from "./SourceTypeFilter.vue?vue&type=script&lang=js"
export * from "./SourceTypeFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__